
module.exports = { 
      attributes: {},
    
      body: "# Visca developer console identity\n\nWordmarks follow the Visca / Developers identity in `autonomy-cloud/visca-site`.\nThe loader and favicon use the simple Mellow mark from that repository’s\n`src/components/mellow/MellowMark.tsx`, placed on a lilac icon tile.\nOperational portal screens retain the professional editorial design without mascot artwork.\n",
     }